// The education board a school follows. Admin-editable only; captured at registration.
export const EDUCATION_BOARDS = [
  'CBSE',
  'CISCE (ICSE/ISC)',
  'IB',
  'Cambridge',
  'State Board',
  'Other',
];

// These two need the specific board naming, since "State Board" alone says little.
export const BOARDS_NEEDING_DETAIL = ['State Board', 'Other'];

export const boardLabel = (school) => {
  if (!school?.education_board) return '—';
  return school.education_board_detail
    ? `${school.education_board} · ${school.education_board_detail}`
    : school.education_board;
};
